const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isValidFranchiseUuid = (value?: string): boolean =>
  Boolean(value && UUID_PATTERN.test(value));

export const resolveFranchiseContextUuid = (
  requestedFranchiseUuid?: string,
  storedFranchiseUuid?: string | null,
  authFranchiseUuid?: string
): string => {
  if (isValidFranchiseUuid(requestedFranchiseUuid)) return requestedFranchiseUuid || '';
  if (isValidFranchiseUuid(storedFranchiseUuid || undefined)) return storedFranchiseUuid || '';
  if (isValidFranchiseUuid(authFranchiseUuid)) return authFranchiseUuid || '';
  return '';
};
